import { render, staticRenderFns } from "./MembersAutocomplete.vue?vue&type=template&id=648d069b&scoped=true"
import script from "./MembersAutocomplete.vue?vue&type=script&lang=js"
export * from "./MembersAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d069b",
  null
  
)

export default component.exports